import { createFileRoute } from '@tanstack/react-router';
import { AiAssistantsPage } from '@/features/mcp/AiAssistantsPage';

export const Route = createFileRoute('/_app/settings/ai-assistants')({ component: AiAssistantsPage });
